export default "__VITE_ASSET__130a9f37__"